export function randomNumber(){
    return Math.floor(Math.random() * 1E16)
}

export function parseBreakLines(str){
    if(!str){
        return str;
    }
    return str.replace(/(?:\n\r|\r|\n|\\n|\\r)/g, '<br>');
}